<template>
  <div>
    <el-row :gutter="5">
      <el-form ref="params" :model="params">
        <el-col :span="4" :xs="24">
          <SearchByMemberAndCard2 ref="SearchByMemberAndCard2" />
        </el-col>
        <el-col :span="2" :xs="12">
          <el-form-item prop="deviceId">
            <el-input
              v-model="params.deviceId"
              maxlength="6"
              placeholder="设备编号"
            />
          </el-form-item>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-form-item prop="ids">
            <el-input
              v-model="params.ids"
              maxlength="6"
              placeholder="硬件UID"
            />
          </el-form-item>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-form-item prop="qrCodeId">
            <el-input v-model="params.qrCodeId" placeholder="主机二维码" />
          </el-form-item>
        </el-col>
        <el-col :span="3" :xs="12">
          <el-form-item prop="paramsDeviceId">
            <el-select
              v-model="paramsDeviceId"
              :loading="loadingDevice"
              :remote-method="remoteMethodDevice"
              id="el-select"
              @focus="closeReadOnly"
              @hook:mounted="closeReadOnly"
              @visible-change="closeReadOnly"
              filterable
              placeholder="请输入设备名称"
              remote
              reserve-keyword
              @change="handleDeviceIdChange"
            >
              <el-option
                v-for="(item, index) in optionsDevice"
                :key="index"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-form-item prop="online">
            <el-select v-model="params.state" placeholder="状态">
              <el-option
                v-for="item in status"
                :key="item.label"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" :xs="24">
          <!-- <el-date-picker
            v-model="time"
            :clearable="false"
            :picker-options="pickerOptions"
            end-placeholder="结束日期"
            range-separator="至"
            start-placeholder="开始日期"
            type="daterange"
            value-format="timestamp"
          /> -->
          <!-- <lp-date-picker
            ref="lpDatePicker"
            @finish="handleLpDatePickerChange"
          /> -->
        </el-col>
        <el-col :span="2" :xs="12">
          <el-button type="primary" @click="search">搜索</el-button>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-button plain type="success" @click="reset">重置</el-button>
        </el-col>
      </el-form>
    </el-row>
    <el-table
      v-loading="loadTable"
      :data="records"
      stripe
      @sort-change="sort_change"
      :default-sort="{ prop: 'id', order: 'descending' }"
    >
      <el-table-column
        fixed
        label="ID"
        prop="id"
        sortable="custom"
        width="90"
      />
      <el-table-column label="手机号/电卡" prop="phone" width="120" />
      <el-table-column label="订单类型" prop="memberType">
        <template #default="scope">
          {{
            scope.row.orderType == "7"
              ? "预付费"
              : scope.row.orderType == "6"
              ? "即插即充"
              : scope.row.memberType == "1"
              ? "微信"
              : scope.row.memberType == "7"
              ? "支付宝"
              : "电卡"
          }}
        </template>
      </el-table-column>
      <el-table-column label="设备编号" prop="deviceId" />
      <el-table-column label="设备名称" width="150">
        <template #default="scope">
          <el-tooltip
            effect="dark"
            :content="scope.row.chargePileName"
            placement="top-start"
          >
            <div class="text_ellipsis_1">
              {{ scope.row.chargePileName }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="端口号" prop="socketNum">
        <template #default="scope">
          {{ scope.row.socketNum }}{{ scope.row.ab === 0 ? "A" : "B" }}
        </template>
      </el-table-column>
      <el-table-column label="开始时间" width="150" prop="startTime">
        <template #default="scope">
          {{
            scope.row.startTime === 0
              ? "未开始"
              : timeFormat(scope.row.startTime)
          }}
        </template>
      </el-table-column>
      <el-table-column label="结束时间" width="150" prop="endTime">
        <template #default="scope">
          <template v-if="scope.row.endTime === 0"> 充电中 </template>
          <template v-else>
            {{ timeFormat(scope.row.endTime) }}
          </template>
        </template>
      </el-table-column>
      <el-table-column label="充电时长">
        <template #default="scope">
          {{
            scope.row.startTime === 0
              ? scope.row.startTime
              : differTime(scope.row.startTime, scope.row.endTime)
          }}分钟
        </template>
      </el-table-column>
      <el-table-column label="金额" prop="money" />
      <el-table-column label="使用豆币" prop="token" />
      <el-table-column label="使用余额" prop="balanceUsed" />
      <el-table-column label="度数">
        <template #default="scope">
          {{
            new BigNumber(scope.row.powerConsumption).plus(
              new BigNumber(scope.row.powerConsumptionStop || 0)
            )
          }}
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="state">
        <template #default="scope">
          <template v-if="scope.row.state === '1'"> 等待连接 </template>
          <template v-else-if="scope.row.state === '2'"> 充电中 </template>
          <template v-else-if="scope.row.state === '3'"> 暂停 </template>
          <template v-else-if="scope.row.state === '4'"> 完成 </template>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="250">
        <template #default="scope">
          <el-button size="mini" @click="detail(scope.row.id)">详细</el-button>
          <el-button
            size="mini"
            v-if="showWave(scope.row.endTime)"
            @click="wave(scope.row.id)"
            >功率图</el-button
          >
          <el-button
            v-if="
              scope.row.state === '1' ||
              scope.row.state === '2' ||
              scope.row.state === '3'
            "
            size="mini"
            type="danger"
            @click="finish(scope.row.id)"
            >结束
          </el-button>
          <el-button
            v-if="
              scope.row.state === '4' &&
              scope.row.isRefund === '0' &&
              scope.row.money > 0
            "
            size="mini"
            type="success"
            @click="refundOrder(scope.row.id)"
            >退单
          </el-button>
          <el-button
            v-if="scope.row.state === '4' && scope.row.isRefund === '1'"
            disabled
            size="mini"
            type="info"
            >已退单
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <page :current="current" :size="size" :total="total" />
    <OrderDetailsDialog :id="id" :dialog="orderDetailsDialog" />
    <finish-order-dialog :id="id" :dialog="finishOrderDialog" />
    <wave-dialog :id="id" :dialog="waveDialog" />
    <refund-order-dialog :id="id" :dialog="refundOrderDialog" />
  </div>
</template>

<script>
import agentGetOrderListByWhere from "@/api/fund/order-manage/agentGetOrderListByWhere";
import FinishOrderDialog from "@/components/Dialog/finishOrderDialog";
import OrderDetailsDialog from "@/components/Dialog/orderDetailsDialog";
import RefundOrderDialog from "@/components/Dialog/refundOrderDialog";
import WaveDialog from "@/components/Dialog/waveDialog";
import Page from "@/components/Page";
import SearchByMemberAndCard2 from "@/components/SearchByMemberAndCard2";
import createdMixin from "@/mixin/createMixin";
import dialogMixin from "@/mixin/dialogMixin";
import getDeviceMixin from "@/mixin/getDeviceMixin";
import pageMixin from "@/mixin/pageMixin";
import searchMixin from "@/mixin/searchMixin";
import timeMixin from "@/mixin/timeMixin";
import BigNumber from "bignumber.js";

export default {
  name: "RechargeOrder",
  components: {
    RefundOrderDialog,
    WaveDialog,
    FinishOrderDialog,
    OrderDetailsDialog,
    Page,
    SearchByMemberAndCard2,
  },
  mixins: [
    pageMixin,
    createdMixin,
    timeMixin,
    searchMixin,
    dialogMixin,
    getDeviceMixin,
  ],
  data() {
    return {
      BigNumber,
      waveDialog: false,
      id: undefined,
      finishOrderDialog: false,
      orderDetailsDialog: false,
      refundOrderDialog: false,
      time: [],
      records: [],
      params: {
        deviceId: undefined,
        ids: undefined,
        qrCodeId: undefined,
        name: undefined,
        socketNum: undefined,
        memberId: undefined,
        memberType: undefined,
        state: undefined,
        sortName: "id",
        sortType: "DESC",
      },
      paramsDeviceId: undefined,
      status: [
        //1等待连接，2充电中，3暂停，4完成
        { value: "1", label: "等待连接" },
        { value: "2", label: "充电中" },
        { value: "3", label: "暂停" },
        { value: "4", label: "完成" },
      ],
    };
  },
  methods: {
    handleDeviceIdChange(value) {
      this.$set(this.params, "deviceId", value);
    },
    showWave(endTime) {
      return (
        endTime > new Date().valueOf() / 1000 - 60 * 60 * 24 * 7 ||
        endTime === 0
      );
    },
    resetFields() {
      this.params.ids = undefined;
      this.params.qrCodeId = undefined;
      this.params.state = undefined;
      this.paramsDeviceId = undefined;
    },
    sort_change(e) {
      this.params.sortName = e.prop;
      this.params.sortType = e.order == "descending" ? "DESC" : "ASC";
      if (e.order == null) {
        this.params.sortName = null;
        this.params.sortType = null;
      }
      this.fetchData();
    },
    closeReadOnly(val) {
      this.$nextTick(() => {
        if (!val) {
          const timer = setTimeout(() => {
            document.getElementById("el-select").removeAttribute("readonly");
            clearTimeout(timer);
          }, 200);
        }
      });
    },
    refundOrder(id) {
      this.id = id;
      this.refundOrderDialog = true;
    },
    wave(id) {
      this.id = id;
      this.waveDialog = true;
    },
    detail(id) {
      this.id = id;
      this.orderDetailsDialog = true;
    },
    finish(id) {
      this.id = id;
      this.finishOrderDialog = true;
    },
    fetchData() {
      this.loadTable = true;
      // console.log(this.params)
      let sendParams = this.params;
      if (!sendParams.memberId) {
        sendParams.memberType = null;
      }
      agentGetOrderListByWhere(sendParams, this.current, this.size)
        .then((res) => {
          this.total = res.total;
          this.records = res.records;
        })
        .finally(() => {
          this.loadTable = false;
        });
    },
  },
};
</script>
